import React from 'react';
import { makeStyles } from '@mui/styles';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  txtError: {
    fontSize: '12px',
    color: '#f44336',
    textAlign: 'start',
    margin: '5px',
  },
}));

interface IErrorMessageProps {
  children: React.ReactNode;
  className?: string;
}

function ErrorMessage(props: IErrorMessageProps) {
  const classes = useStyles();
  const { children, className, ...rest } = props;
  if (!children) return null;
  return (
    <p className={classnames(classes.txtError, { [className || '']: !!className })} {...rest}>
      {children}
    </p>
  );
}

export default ErrorMessage;
